import styled from "styled-components";

const AdminLeaveSc = styled.div`
  margin: 10px;
  padding: 5px;
  height: 90vh;
  border-radius: 10px;
  /* fallback for old browsers */
  width: 100vw;
  /* Chrome 10-25, Safari 5.1-6 */
  position: absolute;
  top: 45px;
  .search-bar {
    width: 500px;
  }
  .main {
    width: 100%;
    /* padding-top: 80px; */
    padding-bottom: 20px;
  }

  .has-search .form-control {
    padding-left: 2.375rem;
  }
  .admin-leave-conatiner {
    width: 100%;
  }
  .has-search .form-control-feedback {
    position: absolute;
    z-index: 2;
    display: block;
    width: 2.375rem;
    height: 2.375rem;
    line-height: 2.375rem;
    text-align: center;
    pointer-events: none;
    color: #aaa;
  }
  .employee-list-container {
    width: 95vw;

    padding: 10px 12px;
    color: black;
    display: flex;
    justify-content: space-between;
  }
  .admin-navbar {
    position: fixed;
    top: 0;
  }

  .leave-details {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-size: 0.9rem;
    font-weight: 600;
  }

  .leave-details-container {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 40px;
    width: 150px;
    height: 40px;
  }
  .leave-details-available {
    padding-right: 0.1rem;
    display: flex;
    gap: 50px;
    width: 135px;
    justify-content: space-between;
    font-size: 0.9rem;
    font-weight: 600;
  }
  .profile-list {
    width: 200px;
    display: flex;
    justify-content: space-around;
    align-items: center;
  }
  .employee-list {
    width: 150px;
    display: flex;
    align-items: center;
  }
  .employee-list-containers {
    width: 95vw;
    padding: 10px 12px;
    color: black;
    display: flex;
    justify-content: space-between;
    padding: 10px 22px;
    background-color: #edecec;
    margin: 10px;
    border-radius: 5px;
    cursor: pointer;
  }
  .alert-messages {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 90vh;
    font-size: larger;
    font-weight: 800;
  }
  .leave-details-main {
    display: flex;
    width: 135px;
    justify-content: space-between;
    align-items: center;
  }
  .leave-taken {
    background: linear-gradient(
      95deg,
      rgba(96, 176, 240, 1) 12%,
      rgba(18, 111, 186, 1) 65%
    );
    width: 40px;
    height: 40px;
    display: flex;
    justify-content: center;
    color: white;
    align-items: center;
    border-radius: 100%;
  }
  .leave-available {
    background: -webkit-linear-gradient(
      95deg,
      rgb(179, 122, 194) 0%,
      rgba(155, 107, 205, 1) 53%
    );
    width: 40px;
    height: 40px;
    color: white;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 100%;
  }
`;
export default AdminLeaveSc;
